<template>
  <ul class="flex w-full flex-col gap-20">
    <li v-for="questionGroup in questionGroups" :key="questionGroup.id">
      <ul class="flex flex-col gap-10">
        <li v-for="question in questionGroup.questions" :key="question.id + receiverId">
          <ListItemQuestion
            :feedback="
              feedbacks.find(
                (feedback) =>
                  feedback.questionId == question.id &&
                  feedback.questionGroupId == questionGroup.id,
              )
            "
            :hide-keyboard-shortcuts="true"
            @update:feedback="(value) => handleFeedbackUpdate(value, question.id, questionGroup.id)"
            :question="question"
            :feedback-type="questionGroup.feedbackType"
            :scale="
              questionGroup.feedbackType != FeedbackType.Textual ? questionGroup.scale : undefined
            "
            :labels="
              questionGroup.feedbackType != FeedbackType.Textual ? [...questionGroup.labels] : []
            "
          />
        </li>
      </ul>
    </li>
  </ul>
</template>
<script setup lang="ts">
  import { FeedbackType } from '@/core/models/feedback-type'
  import type { JSONContent } from '@tiptap/vue-3'
  import type { Scale } from '@/core/models/scale'
  import ListItemQuestion from '../question/ListItemQuestion.vue'

  interface Props {
    readonly receiverId: string
    questionGroups: ReadonlyArray<{
      readonly id: string
      readonly title?: string
      readonly labels: ReadonlyArray<{
        id: string
        title: string
        key: string
        icon: string
        description?: string
      }>
      readonly feedbackType: FeedbackType
      readonly scale?: Scale
      readonly questions: ReadonlyArray<{
        readonly id: string
        readonly content: string
        readonly scaleItemDescriptions: ReadonlyArray<string>
      }>
    }>
  }
  defineProps<Props>()

  const updateFeedback = (newFeedback: {
    value?: number
    text?: JSONContent
    questionId: string
    questionGroupId: string
  }) => {
    feedbacks.value = [
      ...feedbacks.value.filter((feedback) => feedback.questionId != newFeedback.questionId),
      newFeedback,
    ]
  }

  const handleFeedbackUpdate = (
    value: { value?: number; text?: JSONContent },
    questionId: string,
    questionGroupId: string,
  ) => {
    updateFeedback({
      ...value,
      questionId,
      questionGroupId,
    })
  }

  const feedbacks = defineModel<
    { value?: number; text?: JSONContent; questionId: string; questionGroupId: string }[]
  >({ default: [] })
</script>
